export const FREE_SLOTS_REQUEST = `FREE_SLOTS_REQUEST`;
export const FREE_SLOTS_SUCCESS = `FREE_SLOTS_SUCCESS`;
